import i18n from "../../i18n";

export const fmtClock = (s) => {
  const t = Math.max(0, Math.round(s || 0));
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
};

export const fmtDuration = (s) => {
  const t = Math.max(0, Math.round(s || 0));
  const m = Math.floor(t / 60);
  const r = t % 60;
  if (!m) return `${r} s`;
  return r ? `${m} min ${String(r).padStart(2, "0")} s` : `${m} min`;
};

const locale = () => (i18n.language || "fr").slice(0, 2);
const asDate = (v) => new Date(v.length === 10 ? `${v}T12:00:00` : v);

export const fmtDate = (v, { year = false } = {}) => {
  if (!v) return "—";
  return new Intl.DateTimeFormat(locale(), {
    day: "numeric",
    month: "short",
    ...(year ? { year: "numeric" } : {}),
  }).format(asDate(v));
};

export const fmtDateLong = (v) => {
  if (!v) return "—";
  return new Intl.DateTimeFormat(locale(), {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(asDate(v));
};

export const relativeDays = (v) => {
  if (!v) return i18n.t("Jamais");
  const days = Math.floor((Date.now() - asDate(v).getTime()) / 864e5);
  if (days <= 0) return i18n.t("Aujourd'hui");
  if (days === 1) return i18n.t("Hier");
  if (days < 30) return i18n.t("Il y a {{days}} j", { days });
  return fmtDate(v);
};

export const daysUntil = (v) => {
  if (!v) return null;
  return Math.ceil((new Date(`${v}T23:59:59`).getTime() - Date.now()) / 864e5);
};

export const initials = (first = "", last = "") =>
  `${first[0] || ""}${last[0] || ""}`.toUpperCase();
export const fullName = (op) => (op ? `${op.first_name} ${op.last_name}` : "");
export const ROMAN = ["", "I", "II", "III", "IV", "V"];
/**
 * What a program calls its `levels` (the containers). Two tiers of vocabulary:
 * - "theme" programs: a container is a named, un-numbered THÈME (shown by its title); the
 *   difficulty ramp inside it is "Niveau 1 … 5" (5 = certification). `num` is not used for display.
 * - legacy ("level") programs: a container is a numbered "Niveau I … V" and its steps are "Palier 1 … 5".
 */
export const unitOf = (program) =>
  program?.unit === "theme"
    ? { theme: true, one: "thème", many: "thèmes", num: () => "" }
    : { theme: false, one: "niveau", many: "niveaux", num: (n) => ROMAN[n] };
export const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
/** Title of the container `n` of a program (undefined when unknown). */
export const levelTitle = (program, n) => program?.levels?.find((l) => l.level === n)?.title;
/**
 * Names the container `n`: its title for a theme program (fallback "Thème"), "Niveau III" for a
 * legacy one. `fallbackTitle` serves when the program is not at hand (e.g. a certificate snapshot).
 */
export const levelLabel = (program, n, fallbackTitle) =>
  unitOf(program).theme
    ? levelTitle(program, n) || fallbackTitle || i18n.t("Thème")
    : i18n.t("Niveau {{level}}", { level: ROMAN[n] });
/** Names the difficulty step `order` (1..5) inside a container: "Niveau 2" (theme) or "Palier 2" (legacy). */
export const stepLabel = (program, order) =>
  unitOf(program).theme
    ? i18n.t("Niveau {{order}}", { order })
    : i18n.t("Palier {{order}}", { order });
export const cx = (...a) => a.filter(Boolean).join(" ");
export const pct = (a, b) => (b ? Math.round((a / b) * 100) : 0);

/** Translatable count: tn(t, n, "{{count}} agent", "{{count}} agents") — French: 0 and 1 are singular. */
export const tn = (t, n, one, many) => t(n > 1 ? many : one, { count: n });
